import React from 'react';
import './Chapters.scss';

function Chapter7() {
  return (
    <>
      <section className="chapter">
        <p className="chapter__title">On the Bright Horizon</p>
        <p className="chapter__paragraph">
          For Will and the team at Island Conservation, Lenovo’s edge computing solutions have
          opened a world of possibilities for conservation. But the promise of edge computing
          stretches far beyond preserving fragile ecosystems. Lenovo’s ThinkEdge servers are being
          used by doctors in remote locations and humanitarian crisis zones to give them the same
          computing power they would get from urban hospitals. They’re onboard the boats of
          fishermen in the Gulf of Mexico, who use the ThinkEdge server’s AI capability to monitor
          catches, alerting them when a fish is caught that is either endangered or too small to
          keep.
        </p>
        <p className="chapter__paragraph">
          On Robinson Crusoe Island, recovering the biodiversity hasn’t been easy, but implementing
          Lenovo’s technology resources has given the effort a quantum leap forward. And once a
          single species recovers, the effects can cascade—improving the ecosystem “from ridge to
          reef,” as Will says.
        </p>
      </section>
    </>
  );
}

export default Chapter7;
